import { computed } from 'vue'

/**
 * Event handling composable for MsCheckbox
 * Xử lý các events cho checkbox - GIỮ NGUYÊN logic từ file gốc
 */
export function useCheckboxEvents(props, emit) {
  // Variable
  let focused = false

  // Methods - Giữ nguyên từ file gốc
  const onFocus = () => {
    focused = true
  }

  const onBlur = () => {
    focused = false
  }

  /**
   * Hủy lan rộng event
   * HTHIEP 09.02.2022
   */
  const cancelEvent = e => {
    if (e) {
      if (typeof e.preventDefault === 'function') {
        e.preventDefault()
      }

      if (typeof e.stopPropagation === 'function') {
        e.stopPropagation()
      }

      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation()
      }
    }
  }

  // Event listeners - Giữ NGUYÊN logic từ file gốc
  const listeners = computed(() => {
    return {
      click: event => {
        // emit('click', event); // ← Giữ nguyên comment từ file gốc
      },
      input: () => {
        emit('update:modelValue', !props.modelValue)
      },
      change: event => {
        cancelEvent(event)
        emit('change', props.modelValue, props.label)
      },
      focus: event => {
        onFocus(event)
      },
      blur: event => {
        onBlur(event)
      },
    }
  })

  return {
    focused,
    onFocus,
    onBlur,
    listeners,
    cancelEvent
  }
}
